'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _userSetting = require('../actions/user-setting');

var Actions = _interopRequireWildcard(_userSetting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    isContentDiscoverable: true
};

var httpRequestFailure = function httpRequestFailure(state, error, call) {
    return _extends({}, state, {
        isFetching: 0,
        error: {
            isError: true,
            errorCode: error && error.status ? error.status : null,
            errorMessage: error && error.message ? error.message : null,
            dataCall: call
        }
    });
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case Actions.USER_SETTING_GET_COMPLETE:
            {
                return _extends({}, state, {
                    isContentDiscoverable: action.setting.isContentDiscoverable
                });
            }

        case Actions.USER_SETTING_SET_COMPLETE:
            {
                return _extends({}, state, {
                    isContentDiscoverable: action.setting.isContentDiscoverable
                });
            }

        case Actions.USER_SETTING_SET_FAILURE:
            {
                return httpRequestFailure(state, action.error, action.dataCall);
            }

        case Actions.PRIVATE_SETTING_ERROR_HANDLED:
            {
                return _extends({}, state, {
                    error: {
                        isError: false,
                        errorCode: null,
                        errorMessage: null,
                        dataCall: null
                    }
                });
            }

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/user-setting.js
// module id = 773
// module chunks = 0